var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 3873 3873",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 916.885,
    x2: 2959.811,
    y1: 1025.515,
    y2: 3068.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc00ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00dbde"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "evenodd",
    d: "M2363.1 2104.5v148.9h-849.3v-148.9c0-234.6 190.2-424.7 424.7-424.7 234.6 0 424.7 190.2 424.6 424.7zm10.5 239.6h-870.1c-89.8 0-163.4 73.6-163.4 163.4v595.9c0 89.8 73.6 163.4 163.4 163.4h870.1c89.8 0 163.4-73.6 163.4-163.4V2507.5c0-89.8-73.6-163.4-163.4-163.4zm-389.8 544v132c0 25-20.3 45.3-45.3 45.3s-45.3-20.3-45.3-45.3v-132c-127.9-34.4-173.4-196-77.9-291.5 68-68 178.3-68.1 246.4 0 94.7 94.7 51.3 256.8-77.9 291.5zm-128.9-168.3c0 74.2 90.3 111.5 142.7 59.1 32.7-32.6 32.7-85.5 0-118.2-52.6-52.6-142.7-14.9-142.7 59.1zm1050.5-1387.7c-120.4-218.3-374.6-326.5-615.9-260.2-32.2-81.6-78.9-155.8-136.8-219.5-276.9-304.2-749.7-313-1038.1-24.6C986 956.4 906 1133.6 904.5 1329.4c-392.4 3.1-711.8 321.9-711.8 717.6 0 396.3 321.3 717.6 717.6 717.6h338.9v-257.1c0-111.1 72.3-207 173.8-241.1v-161.9h.2c0-142.3 57.7-271.1 150.9-364.4 201.1-201.1 527.4-201.4 728.8 0 93.3 93.3 150.9 222.1 150.9 364.4v161.9c101.5 34 173.8 130 173.8 241.1v257.1h338.9c397.4 0 717.6-322.6 717.6-717.6 0-420.6-360.8-751.4-778.7-714.9z",
    clipRule: "evenodd",
    opacity: 1,
    "data-original": "url(#a)",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.dc694862c81dbcce7830b3e5f5d79fff.svg";
export { ForwardRef as ReactComponent };